import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const WarningIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 20",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.262 19.987H2.73c-1.7 0-2.73-1.194-2.73-2.705 0-.49.13-.99.409-1.463L8.67 1.37A2.64 2.64 0 0 1 11 .013c.907 0 1.814.45 2.33 1.357l8.261 14.449c.27.466.409.972.409 1.463 0 1.511-1.03 2.705-2.738 2.705Zm-9.006-7.764c.008.49.27.768.744.768.45 0 .72-.27.727-.768l.131-5.745c.008-.49-.36-.85-.866-.85-.515 0-.875.351-.867.842l.131 5.753Zm-.327 3.146c0 .564.49 1.03 1.071 1.03.572 0 1.07-.458 1.07-1.03 0-.58-.49-1.038-1.07-1.038-.588 0-1.07.466-1.07 1.038Z",
    clipRule: "evenodd"
  })
});
export default WarningIcon;